import React, { useCallback, useRef, useState, useEffect } from 'react';
import { useHistory, RouteComponentProps } from 'react-router';
import { ATMContainer, ATMGrid, ATMLoader } from 'shared-it-appmod-ui';
import { ToastSuccess } from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useFireFightingDispatchContext } from 'src/contexts/fire-fighting-dispatch.context';
import NewDispatchFormHeader from '../fire-dispatch-form/new-dispatch-header/new-dispatch-header.component';
import NewDispatchActionButtons from '../fire-dispatch-form/action-buttons/action-buttons.component';
import NewFireDispatchForm from '../fire-dispatch-form/new-dispatch-form.component';

export type IProps = RouteComponentProps<{
  dispatchId: string;
}>;

const FireDispatchEdit: React.FC<IProps> = ({ match }) => {
  const dispatchId = Number(match.params.dispatchId);
  const { state, actions } = useFireFightingDispatchContext();
  const formRef = useRef<HTMLFormElement>(null);
  const shouldReturn = useRef<boolean>(false);
  const history = useHistory();
  const [showLoader, setShowLoader] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!state.helicopterCompanyList.length) {
        await actions.getHelicopterCompanyData();
      }
      if (!state.fireAgency.length) {
        await actions.getFireAgencyData();
      }

      await actions.getFireDispatchDetailsData(dispatchId);

      setShowLoader(false);
    };

    fetchData();
  }, [dispatchId, actions, setShowLoader]);

  const handleSave = useCallback(
    (close) => {
      shouldReturn.current = close;
      if (formRef && formRef.current) {
        formRef.current.handleSubmit();
      }
    },
    [formRef, shouldReturn]
  );

  const handleSubmit = useCallback(
    async (data) => {
      setShowLoader(true);
      const result = await actions.saveFireDispatchData(data, dispatchId);
      // eslint-disable-next-line no-console
      setShowLoader(false);

      if (result.payload) {
        ToastSuccess(Lang.MSG_FIRE_DISPATCH_UPDATE_SUCCESS);

        if (shouldReturn.current) {
          actions.setDefaultData();
          history.push('/dispatch');
        } else {
          history.push(`/dispatch/${dispatchId}/edit`);
        }
      }
    },
    [dispatchId, shouldReturn, setShowLoader]
  );

  if (
    (showLoader && !state.defaultValues) ||
    (state.defaultValues && state.defaultValues.dispatchId !== dispatchId)
  ) {
    return <ATMLoader active />;
  }

  return (
    <ATMContainer>
      <NewDispatchFormHeader handleSave={handleSave} loading={showLoader} />
      <NewFireDispatchForm
        formRef={formRef}
        defaultValues={state.defaultValues}
        handleSubmit={handleSubmit}
      />
      <ATMGrid columns={1} style={{ marginTop: '2rem' }}>
        <ATMGrid.Column textAlign="center" verticalAlign="top">
          <NewDispatchActionButtons
            handleSave={handleSave}
            loading={showLoader}
          />
        </ATMGrid.Column>
      </ATMGrid>
    </ATMContainer>
  );
};

export default FireDispatchEdit;
